import { styled } from '@linaria/react';
import iconSlack from '../../../../assets/icons/iconSlack.svg';
import iconTeams from '../../../../assets/icons/iconTeams.svg';
import { Icon } from '../../../../ui-library/icon/icon';
import { getSectionVisual } from '../agent-customize/agent-customize.constants';
import { GoogleGLogo, Microsoft365Logo } from '../agent-customize/brand-icons';
import { IconTile, type IconTileSize } from '../shared/settings/icon-tile';
import { FloraConnectionId } from './agent-settings.type';

interface ConnectionTileProps {
  /** The connection id; unknown ids fall back to the catalog section icon. */
  connectionId: string;
  size?: IconTileSize;
}

/**
 * Renders a connection's brand logo (Google, Microsoft 365, Slack, Teams) in
 * an icon tile, or the catalog's section icon for any other connection.
 *
 * @param {ConnectionTileProps} props - The connection and tile size
 * @returns {JSX.Element} The connection tile
 */
export function ConnectionTile({ connectionId, size = 'lg' }: ConnectionTileProps) {
  const logoSize = size === 'lg' ? 24 : 20;

  switch (connectionId) {
    case FloraConnectionId.Google:
      return (
        <IconTile background="var(--sky-lightest)" size={size}>
          <GoogleGLogo size={logoSize} />
        </IconTile>
      );
    case FloraConnectionId.Office:
      return (
        <IconTile background="var(--sky-lightest)" size={size}>
          <Microsoft365Logo size={logoSize} />
        </IconTile>
      );
    case FloraConnectionId.Slack:
      return (
        <IconTile background="var(--sky-lightest)" size={size}>
          <Logo src={iconSlack} alt="" width={logoSize} height={logoSize} />
        </IconTile>
      );
    case FloraConnectionId.Teams:
      return (
        <IconTile background="var(--sky-lightest)" size={size}>
          <Logo src={iconTeams} alt="" width={logoSize} height={logoSize} />
        </IconTile>
      );
    default: {
      const visual = getSectionVisual(connectionId);
      return (
        <IconTile background={visual.badgeBg} size={size}>
          <Icon name={visual.icon} size={logoSize} color={visual.color} />
        </IconTile>
      );
    }
  }
}

const Logo = styled.img`
  display: block;
`;

export type { ConnectionTileProps };
